import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Payment.css';
import API_BASE_URL from './config';
import { FaArrowLeft } from 'react-icons/fa';


const Payment = () => {
  const { dealId } = useParams();
  const navigate = useNavigate();
  const [deal, setDeal] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState('UPI'); // Default to UPI
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/deals/${dealId}`);
        if (!response.ok) throw new Error('Failed to fetch deal');
        const data = await response.json();
        setDeal(data);
      } catch (err) {
        setError('Error loading deal details');
        console.error(err);
      }
    };
    fetchDeal();
  }, [dealId]);

  const handlePayment = async (e) => {
    e.preventDefault();
    if (!deal) {
      alert('Deal details not available');
      return;
    }
    setLoading(true);
    try {
      const userId = localStorage.getItem("userId");
      const source = localStorage.getItem("userSource");

      const response = await fetch(`${API_BASE_URL}/api/mock-payment-complete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId,
          source,
          dealId: deal._id,
        }),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.error || "Coupon creation failed");

      alert("Payment Successful! Coupon generated.");
      navigate(`/coupon/${result.couponCode}`);
    } catch (err) {
      alert("Mock payment failed: " + err.message);
    }
  };

  if (error) {
    return <div className="payment-container"><p>{error}</p></div>;
  }

  if (!deal) {
    return <div className="payment-container"><p>Loading deal...</p></div>;
  }

  return (
    <div className="payment-container">
      <button
        className="back-btn"
        onClick={() => navigate(`/deals/${dealId}`)}
        disabled={loading}
      >
        <FaArrowLeft />
      </button>
      <h2>Payment for Deal #{dealId}</h2>
      <form onSubmit={handlePayment}>
        <label>
          Amount
          <input
            type="text"
            value={deal?.newPrice ? `₹${Number(deal.newPrice).toFixed(2)}` : 'Loading...'}
            readOnly
          />
        </label>
        <label>Choose Payment Method</label>
        <div className="payment-methods">
          <label className="payment-method-option">
            <input
              type="radio"
              value="UPI"
              checked={paymentMethod === 'UPI'}
              onChange={(e) => setPaymentMethod(e.target.value)}
              disabled={loading}
            />
            <span>UPI</span>
          </label>
          <label className="payment-method-option">
            <input
              type="radio"
              value="CARD"
              checked={paymentMethod === 'CARD'}
              onChange={(e) => setPaymentMethod(e.target.value)}
              disabled={loading}
            />
            <span>Credit/Debit Card</span>
          </label>
          <label className="payment-method-option">
            <input
              type="radio"
              value="NETBANKING"
              checked={paymentMethod === 'NETBANKING'}
              onChange={(e) => setPaymentMethod(e.target.value)}
              disabled={loading}
            />
            <span>Netbanking</span>
          </label>
          <label className="payment-method-option">
            <input
              type="radio"
              value="WALLET"
              checked={paymentMethod === 'WALLET'}
              onChange={(e) => setPaymentMethod(e.target.value)}
              disabled={loading}
            />
            <span>Wallet</span>
          </label>
        </div>
        <button type="submit" className="pay-btn" disabled={loading}>
          {loading ? 'Processing...' : 'Proceed to Pay'}
        </button>
      </form>
    </div>
  );
};

export default Payment;